import React, { useState } from 'react';
import './quickplay.css';
import { goBack, goToScreen } from '../../actions/router';
import { connect } from 'react-redux';
import {
    DEBATE_GAME_SCREEN,
    INQUIRY_GAME_SCREEN,
    MEETINGS_GAME_SCREEN,
    MESSAGES_GAME_SCREEN,
    PRESS_GAME_SCREEN,
    QUESTIONS_GAME_SCREEN,
    QUICKPLAY_SCREEN,
    SETTINGS_SCREEN,
    VOTE_GAME_SCREEN,
} from '../../constants/routes';
import { TabMenu } from '../../components/tab-menu';
import { IconButton } from '../../components/icon-button';
import { TextButton } from '../../components/text-button';
import { Icon } from '../../components/icon';
import { Paragraph } from '../../components/paragraph';
import Copy from '../../copy/quickplay';
import { Heading } from '../../components/heading';
import { logAnalyticsEvent } from '../../helpers/analytics';
const gameScreens = {
    messages: MESSAGES_GAME_SCREEN,
    press: PRESS_GAME_SCREEN,
    meetings: MEETINGS_GAME_SCREEN,
    debate: DEBATE_GAME_SCREEN,
    inquiry: INQUIRY_GAME_SCREEN,
    questions: QUESTIONS_GAME_SCREEN,
    vote: VOTE_GAME_SCREEN,
};

const QuickplayScreen = props => {
    const { goToScreen, goBack, startGame } = props;

    const [activeGame, setActiveGame] = useState(null);

    return (
        <div className="quickplay">
            <div className="quickplay__header">
                <IconButton
                    iconName="back"
                    type="essential"
                    size="small"
                    onClick={() => goBack()}
                    withSpacing={true}
                />
                <div className="quickplay__active-game-container">
                    <div className="quickplay__active-game-icon-container">
                        <div className="quickplay__active-game-icon">
                            <Icon
                                size="x-large"
                                iconName={'detailed-' + activeGame}
                            />
                        </div>
                    </div>
                    <main className="quickplay__active-game-info">
                        {activeGame !== null ? (
                            <>
                                <div className="quickplay__active-game-info-child">
                                    <Heading
                                        withSpacing={false}
                                        colorScheme="dark"
                                        headingType="h3"
                                    >
                                        {Copy[activeGame].title}
                                    </Heading>
                                    <Paragraph
                                        withSpacing={false}
                                        colorScheme="dark"
                                    >
                                        {Copy[activeGame].desc}
                                    </Paragraph>
                                </div>
                            </>
                        ) : (
                            <div className="quickplay__active-game-info-child">
                                <Heading
                                    withSpacing={false}
                                    colorScheme="dark"
                                    headingType="h4"
                                >
                                    Please select a game
                                </Heading>
                            </div>
                        )}
                        <div className="quickplay__active-game-info-text-button">
                            <TextButton
                                onClick={() => startGame(activeGame)}
                                text="Start"
                                isDisabled={activeGame === null}
                            />
                        </div>
                    </main>
                </div>
                <IconButton
                    iconName="settings"
                    type="essential"
                    size="small"
                    onClick={() => goToScreen(SETTINGS_SCREEN)}
                    withSpacing={true}
                />
            </div>

            <div className="quickplay__menu">
                <TabMenu
                    screen={QUICKPLAY_SCREEN}
                    setActiveGame={setActiveGame}
                />
            </div>
        </div>
    );
};

const mapDispatchToProps = dispatch => {
    return {
        goBack: () => {
            dispatch(goBack());
        },
        goToScreen: route => {
            dispatch(goToScreen(route));
        },
        startGame: activeGame => {
            logAnalyticsEvent(activeGame + '-game-played-quickplay');
            dispatch(goToScreen(gameScreens[activeGame]));
        },
    };
};

const connected = connect(null, mapDispatchToProps)(QuickplayScreen);
export { connected as QuickplayScreen };
